export default __webpack_public_path__ + "static/media/scatteredclouds.f77b3793.jpg";